import type { AgentPhoneCallResponse } from "@przezmorze/api-types";
import { przezmorzeApi } from "../../../api/api";

export type { AgentPhoneCallResponse as AdminAgentPhoneCallResponse };

export interface ListAgentPhoneCallsAdminParams {
  readonly dateFrom: string;
  readonly dateTo: string;
  readonly agentId?: string;
}

export async function listAgentPhoneCallsAdmin(
  params: ListAgentPhoneCallsAdminParams,
  signal?: AbortSignal,
): Promise<AgentPhoneCallResponse[]> {
  const response = await przezmorzeApi.get<{ items: AgentPhoneCallResponse[] }>("/agent-phone-calls", {
    params,
    signal,
  });
  return response.data.items;
}
